import { StaticPropsContext } from '@otovo/shared/lib/next/types';
import { Otovo$Config } from '@otovo/shared/types/otovoweb';
import StorefrontPage from '../components/StorefrontPage';
import { getStaticProps as getDefaultProps } from '../config/getProps';
import SupportPage from '../components/SupportPage/SupportPage';
import React from 'react';

type Props = {
  config: Otovo$Config;
};

const Contact = ({ config }: Props): React.ReactNode => {
  return (
    <StorefrontPage config={config}>
      <SupportPage />
    </StorefrontPage>
  );
};

export async function getStaticProps(context: StaticPropsContext) {
  const { props } = await getDefaultProps(context);
  return {
    props: { ...props },
  };
}
export default Contact;
